<template>
  <div v-if="screenShares.length > 0" class="call_area screen" style="
    display: flex;
    align-items: center;
    justify-content: center;
">
    <ScreenShare
        v-for="screenShare in screenShares"
        v-bind:key="screenShare.user_id"
        v-bind:screen-share="screenShare"
        class="screen_cast"
    />
  </div>
</template>

<script>
import ScreenShare from "@/components/ScreenShare";

export default {
  name: "ScreenShareGrid",
  components: {ScreenShare},
  computed: {
    screenShares() {
      return this.$store.state.meeting.screenShares;
    },
  },
};
</script>

<style scoped>
</style>
